//if(NODE_ENV == 'development') console.log(NODE_ENV)

window.$ = require("jquery/dist/jquery.min.js");
import dragula from 'dragula'
import Vue from 'vue'

import vSelect from 'vue-select'
//var VueValidator = require('vue-validator')

import { store } from './store'
import router from './router'

import App from './App.vue'
/*
import VueDialog from 'vue-dialog'
Vue.use(VueDialog)
*/
Vue.component('v-select', vSelect)

//import ImageUploader from 'vue-image-upload-resize'
//Vue.use(ImageUploader);

import VuejsDialog from "vuejs-dialog"
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.use(VuejsDialog)
import AcceptOffer from './components/Opq/tags/AcceptOffer.vue';
Vue.dialog.registerComponent('accept-offer', AcceptOffer);
import RejectTeslaOffer from './components/Opq/tags/RejectTeslaOffer.vue';
Vue.dialog.registerComponent('reject-tesla-offer', RejectTeslaOffer);
import RejectOffer from './components/Opq/tags/RejectOffer.vue';
Vue.dialog.registerComponent('reject-offer', RejectOffer);
import ExportDialog from './components/Opq/tags/ExportDialog.vue';
Vue.dialog.registerComponent('export-dialog', ExportDialog);

import SmsDialog from './components/Opq/tags/SmsDialog.vue';
Vue.dialog.registerComponent('sms-dialog', SmsDialog);
import FinishDialog from './components/Opq/tags/FinishDialog.vue';
Vue.dialog.registerComponent('finish-dialog', FinishDialog);
import DeleteDialog from './components/Opq/tags/DeleteDialog.vue';
Vue.dialog.registerComponent('delete-dialog', DeleteDialog);

import Lightbox from './components/Lightbox.vue'
Vue.component('lightbox', Lightbox);

import Modal from './components/Modal.vue'
Vue.component('modal', Modal);

import VeeValidate from 'vee-validate';

VeeValidate.Validator.extend('slug', {
    getMessage(field, params, data) {return (data && data.message) || 'Something went wrong';},
    validate(value) {
        return new Promise(resolve => {
            resolve({
                valid: value.match(/^([a-z]|\d)+((\-|\_)([a-z]|\d)+)*$/g) ? true : false,
                data: value.match(/^([a-z]|\d)+((\-|\_)([a-z]|\d)+)*$/g) ? value : { message: 'Please enter valid slug. Valid letters:a-z0-9-_' }
            });
        });
    }
});
Vue.use(VeeValidate);

import Api from './plugins/Api.js'
Vue.use(Api, {})

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import ui from './mixins/ui.js'
import request from './mixins/request.js'

Vue.directive('dragula', {
  bind: function (el, binding, vnode) {
    var listenerBinded,
        damages = binding.value.damages,
        listener = function(ev){
          if(ev.target.parentElement.id != 'car-model') return;

          var top = ((ev.target.offsetTop + ev.layerY)/container.clientHeight*100).toFixed(2);
          var left = ((ev.target.offsetLeft + ev.layerX)/container.clientWidth*100).toFixed(2);

          if(top < 0 || top > 100 || left < 0 || left > 100) return;

          damages[parseInt(this.el.innerText)-1].position = {
            top: top,
            left: left,
          }
        }
    var container = el;
    dragula([container],{
      moves: function (dragEl, source, handle, sibling) {
        let re = /(^|\s)marker($|\s)/i;
        if(dragEl.className.match(re)) return true;
        return false;
      },
    })
        .on('drag', function (dragEl) {
          var data = {el:dragEl};
          listenerBinded = listener.bind(data);
          container.addEventListener('mousemove', listenerBinded, false);
        })
        .on('dragend', function (dragEl) {
          container.removeEventListener('mousemove', listenerBinded);
        });
  },
});

window.vm = new Vue({
  el: '#app',
  store,
  router,
  delimiters: ['${','}'],
  mixins: [ui, request],
  render: h => h(App),
  modal: {}
})

if (module.hot) {
  const hotEmitter = require("webpack/hot/emitter");
  const DEAD_CSS_TIMEOUT = 2000;

  hotEmitter.on("webpackHotUpdate", function(currentHash) {
    document.querySelectorAll(".webpack-stylesheet").forEach((link) => {
      const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      const newLink = link.cloneNode();
      newLink.href = nextStyleHref;

      link.parentNode.appendChild(newLink);
      setTimeout(() => {
        link.parentNode.removeChild(link);
      }, DEAD_CSS_TIMEOUT);
    });
  })
}


// WEBPACK FOOTER //
// ./requests/assets/src/main.js